var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.posts)?_c('div',[_vm._l((_vm.posts),function(post,index){return _c('div',{key:index},[_c('blog-summary-card',{attrs:{"post":post}})],1)}),_c('older-post',{on:{"increment-page":_vm.loadOldPosts}})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }